import axiosClient from '../axiosClient';
import { DriverRatingsEndpoints } from '../endpoints/driverRatings';
import {
  IDriverRatingSummariesParams,
  IDriverRatingsParams,
  IGetDriverRatingSummariesResponse,
  IGetDriverRatingsResponse,
} from '../../types/api/response/driverratingsresponse';

export const DriverRatingsService = {
  async searchDriverRatings(
    params: IDriverRatingSummariesParams,
  ): Promise<IGetDriverRatingSummariesResponse> {
    const res = await axiosClient.get<IGetDriverRatingSummariesResponse>(
      DriverRatingsEndpoints.SEARCH_DRIVER_RATINGS,
      { params },
    );
    return res.data;
  },

  async getDriverRatings(
    source: string,
    driverId: string,
    params: IDriverRatingsParams,
  ): Promise<IGetDriverRatingsResponse> {
    const res = await axiosClient.get<IGetDriverRatingsResponse>(
      DriverRatingsEndpoints.GET_DRIVER_RATINGS(source, driverId),
      { params },
    );
    return res.data;
  },
};
